<template>
  <transition name="appear">
    <div
      v-if="isOpen"
      class="cookie"
      :class="containerPosition"
      data-cy="cookie-banner">
      <div class="container cookie__wrapper">
        <p class="cookie__content">
          Мы&nbsp;используем файлы cookies и&nbsp;сервис Яндекс.Метрика.
          Оставаясь на&nbsp;сайте, вы&nbsp;соглашаетесь с&nbsp;<a
            :href="POLICY_URL"
            target="_blank"
            rel="noopener noreferrer"
            class="link"
            >Политикой обработки персональных данных</a
          >.
        </p>
        <div class="cookie__buttons">
          <BaseButton
            class="cookie__button accept"
            data-cy="cookie-accept"
            size="sm"
            theme="primary-border"
            @click="accept">
            Понятно
          </BaseButton>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { getCookie, setCookie } from "@/utils/cookies";

export default {
  name: "CookieBanner",
  props: {
    position: {
      type: String,
      default: "bottom",
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    containerPosition() {
      return `cookie__${this.position}`;
    },
  },
  created() {
    this.POLICY_URL = `${process.env.VUE_APP_TALENT_BASE_URL}/policy`;
    this.ACCEPT_COOKIE_NAME = "shown_cookie_banner";
    this.ACCEPT_COOKIE_TTL = 365; // seconds (1 year)
  },
  mounted() {
    const isInIframe =
      typeof window !== "undefined" && window.self !== window.top;
    if (isInIframe) {
      this.isOpen = false;
      return;
    }

    this.isOpen = !getCookie(this.ACCEPT_COOKIE_NAME);
  },
  methods: {
    accept() {
      this.isOpen = false;
      // use existing cookies util signature: setCookie(name, value, days)
      const days = Math.ceil(this.ACCEPT_COOKIE_TTL);
      setCookie(this.ACCEPT_COOKIE_NAME, true, days);
    },
  },
};
</script>

<style lang="less" scoped>
.cookie {
  position: fixed;
  background: #ffffff;
  z-index: 9999;
  width: 100%;
  font-size: 0.95rem;
  box-shadow: 0px -2px 6px fade(@primary-color, 20%);

  &__wrapper {
    display: flex;
    align-items: center;
    padding: 12px 10px;
    @media screen and (max-width: @screen-sm) {
      & {
        flex-direction: column;
      }
    }
  }
  &__content {
    display: block;
    margin-right: 10px;
    flex-grow: 1;
    text-align: left;

    @media screen and (max-width: @screen-sm) {
      & {
        margin-bottom: 20px;
      }
    }
  }

  &__buttons {
    min-width: 200px;
    flex-wrap: wrap;
    margin: auto;
    @media screen and (max-width: @screen-sm) {
      & {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }

  &__button {
    width: 100%;

    @media screen and (max-width: @screen-sm) {
      & {
        width: initial;
      }
    }

    &.deny {
      margin-top: 10px;
      @media screen and (max-width: @screen-sm) {
        & {
          margin-top: 0;
        }
      }
    }
  }
  &__top {
    top: 0;
    left: 0;
    right: 0;
  }
  &__bottom {
    bottom: 0;
    left: 0;
    right: 0;
  }
}

.appear-enter-active,
.appear-leave-active {
  max-height: 100%;
  opacity: 1;
  transition: max-height 1s, opacity 0.3s;
}
.appear-enter {
  max-height: 0;
}
.appear-leave-to {
  opacity: 0;
}
</style>
